module.exports = __webpack_public_path__ + "img/background.f9ddf404.jpg";